import { Locale } from 'types';

export const changeOrderOfferTranslations = {
  [Locale.en]: {
    helmetTitle: 'Agreement Amendment | LightReach',
    // Prefixed with the ordinal word (First/Second/Third…) computed from the CO's addendum
    // sequence — see AMENDMENT_ORDINAL_WORDS in ChangeOrderOffer.tsx.
    headingPpa: 'Amendment to Your Power Purchase Agreement',
    headingLease: 'Amendment to Your Solar Lease Agreement',
    proposedBy: 'Proposed by',
    changesTitle: 'Summary of changes',
    fieldColumn: 'Item',
    previousColumn: 'Current',
    updatedColumn: 'Updated',
    unchangedTitle: 'What is staying the same',
    valueColumn: 'Current value',
    allTermsRemain: 'All other terms of your original agreement remain in force.',
    originalContract: 'View your original agreement',
    fullContract: 'Full amended contract',
    accept: 'Accept amendment',
    decline: 'Decline',
    acceptDisclaimer: 'By clicking Accept, you agree to the terms of this amendment.',
    contractExpires: 'Offer expires on',
    errorLoading: 'Unable to load this amendment. Please try again.',
    acceptError: 'Something went wrong. Please try again.',
    declineError: 'Something went wrong. Please try again.',
    expired: 'Sorry, this amendment offer is no longer available.',
    voided: 'This amendment has been voided.',
    awaitingDisclosure:
      'This amendment is on hold until you sign the required Illinois Shines disclosure. Please check your email for that request before this amendment can be accepted.',
    declineModalHeading: 'Decline this amendment',
    declineModalBody:
      'Declining is final and ends this amendment for all signers. Your original agreement stays in force.',
    declineReasonLabel: 'Reason for declining',
    declineReasonPlaceholder: 'Tell us why you are declining',
    declineReasonRequired: 'A reason is required',
    declineSubmit: 'Confirm decline',
    cancel: 'Cancel',
    confirmationHeading: 'You are all set',
    confirmationBodySolo: 'We have recorded your acceptance for',
    confirmationBodyAdditionalSignersBefore: 'Your acceptance has been recorded. We are still waiting on',
    confirmationBodyAdditionalSignersAfter: 'to accept before the amendment takes effect.',
    declinedHeading: 'Amendment declined',
    declinedBody: 'You have declined this amendment. Your original agreement remains in force.',
    executedHeading: 'Amendment complete',
    executedBody:
      'This amendment has been finalized and is now in effect. Your agreement reflects the updated terms.',
    confirmationQuestion: 'Do you have more questions?',
    confirmationContactBefore: 'Reach out to',
    confirmationOr: 'or',
    contactEmail: 'help@lightreach.com',
    contactPhone: '(800) 597-8527',
  },
  [Locale.es]: {
    helmetTitle: 'Enmienda del Acuerdo | LightReach',
    // Prefixed with the ordinal word (Primera/Segunda/Tercera…) computed from the CO's addendum
    // sequence — see AMENDMENT_ORDINAL_WORDS in ChangeOrderOffer.tsx.
    headingPpa: 'Enmienda a su Acuerdo de Compra de Energía',
    headingLease: 'Enmienda a su Contrato de Arrendamiento Solar',
    proposedBy: 'Propuesto por',
    changesTitle: 'Resumen de cambios',
    fieldColumn: 'Concepto',
    previousColumn: 'Actual',
    updatedColumn: 'Actualizado',
    unchangedTitle: 'Lo que se mantiene igual',
    valueColumn: 'Valor actual',
    allTermsRemain: 'Todos los demás términos de su acuerdo original permanecen vigentes.',
    originalContract: 'Ver su acuerdo original',
    fullContract: 'Contrato enmendado completo',
    accept: 'Aceptar enmienda',
    decline: 'Rechazar',
    acceptDisclaimer: 'Al hacer clic en Aceptar, usted acepta los términos de esta enmienda.',
    contractExpires: 'La oferta vence el',
    errorLoading: 'La enmienda no pudo ser cargada. Por favor, inténtelo de nuevo.',
    acceptError: 'Algo salió mal. Por favor, inténtelo de nuevo.',
    declineError: 'Algo salió mal. Por favor, inténtelo de nuevo.',
    expired: 'Lo sentimos, esta oferta de enmienda ya no está disponible.',
    voided: 'Esta enmienda ha sido anulada.',
    awaitingDisclosure:
      'Esta enmienda está en espera hasta que usted firme la divulgación requerida de Illinois Shines. Por favor revise su correo electrónico para completar ese paso antes de que esta enmienda pueda ser aceptada.',
    declineModalHeading: 'Rechazar esta enmienda',
    declineModalBody:
      'El rechazo de esta enmienda es definitivo y da por concluido el proceso para todos los firmantes, manteniendo la vigencia del acuerdo original.',
    declineReasonLabel: 'Motivo del rechazo',
    declineReasonPlaceholder: 'Díganos por qué está rechazando',
    declineReasonRequired: 'Se requiere un motivo',
    declineSubmit: 'Confirmar rechazo',
    cancel: 'Cancelar',
    confirmationHeading: 'Todo listo',
    confirmationBodySolo: 'Hemos registrado su aceptación para',
    confirmationBodyAdditionalSignersBefore: 'Su aceptación ha sido registrada. Todavía estamos esperando a',
    confirmationBodyAdditionalSignersAfter: 'para aceptar antes de que la enmienda entre en vigor.',
    declinedHeading: 'Enmienda rechazada',
    declinedBody: 'Ha rechazado esta enmienda. Su acuerdo original permanece vigente.',
    executedHeading: 'Enmienda completada',
    executedBody:
      'El proceso de enmienda ha concluido exitosamente y entra en vigor formalmente, actualizando las condiciones del acuerdo anterior.',
    confirmationQuestion: '¿Tiene más preguntas?',
    confirmationContactBefore: 'Comuníquese con',
    confirmationOr: 'o',
    contactEmail: 'help@lightreach.com',
    contactPhone: '(800) 597-8527',
  },
};
